export default __webpack_public_path__ + "static/media/banner.af72d156.jpeg";